module.exports = {
  externalPayProviderSelector: {
    label: 'Select your electronic transfer method:',
  },
  paymentMethodInfo: {
    achpse: 'You will be redirected to the website of the bank you select to authorize the debit of the funds. Available for savings, checking or electronic deposit accounts.',
    bancolombia: 'Available for checking and savings accounts. By choosing this payment method, you will be redirected to the Bancolombia website.',
  },
  fawryLabel: 'الدفع باستخدام فوري',
};
